import { render } from "./EmployeeFormStepView.vue?vue&type=template&id=6c5549c6&scoped=true"
import script from "./EmployeeFormStepView.vue?vue&type=script&lang=js"
export * from "./EmployeeFormStepView.vue?vue&type=script&lang=js"

import "./EmployeeFormStepView.vue?vue&type=style&index=0&id=6c5549c6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\mridu\\BGI_Project\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c5549c6"]])

export default __exports__